export default [
  {
    path: "hot-stocking",
    name: "HotStocking",
    component: () => import("../pages/stocking/HotStocking.vue"),
    meta: {
      title: "爆款备货",
    },
  },
  {
    path: "hot-stocking/create",
    name: "Create",
    component: () => import("../pages/stocking/components/Create.vue"),
    meta: {
      title: "新建首次备货",
    },
  },
  {
    path: "hot-stocking/edit/:id",
    name: "Edit",
    component: () => import("../pages/stocking/components/Edit.vue"),
    meta: {
      title: "编辑首次备货",
    },
  },
  // 备货草稿 首次备货的备货草稿在上面
  {
    path: "hot-stocking/edit-both/:id",
    name: "EditBoth",
    component: () => import("../pages/stocking/EditBoth.vue"),
    meta: {
      title: "编辑多次备货",
    },
  },
  // 长青款备货草稿
  {
    path: "hot-stocking/edit-Green/:id",
    name: "EditGreen",
    component: () => import("../pages/stocking/EditGreen.vue"),
    meta: {
      title: "编辑常青款备货",
    },
  },
  // 多次备货
  {
    path: "hot-stocking/create-more-times",
    name: "CreateMoreTimes",
    component: () => import("../pages/stocking/CreateMoreTimes.vue"),
    meta: {
      title: "新建多次备货",
    },
  },

  // 长青款备货
  {
    path: "hot-stocking/create-allways-green",
    name: "CreateAllwaysGreen",
    component: () => import("../pages/stocking/CreateAllwaysGreen.vue"),
    meta: {
      title: "新建常青款备货",
    },
  },
  {
    path: "hot-stocking/create-manual",
    name: "CreateManual",
    component: () => import("../pages/stocking/CreateManual.vue"),
    meta: {
      title: "手动创建爆款备货",
    },
  },
  {
    path: "hot-stocking/edit-manual/:id",
    name: "EditManual",
    component: () => import("../pages/stocking/EditManual"),
    meta: {
      title: "编辑手动创建爆款备货",
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/hotStockingRouter.js